import React from 'react';
import './footer.css';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import logo from '../logo.svg';

// Every string here goes through t(). The footer renders on every page, so
// it was the loudest half of "the site doesn't translate": the country
// selector was switching the i18n language correctly, but this component
// never asked i18n for anything. Brand and format names (StarView Cinema,
// IMAX, Dolby, Facebook) stay as-is by design - they are names, not copy.
const Footer = () => {
  const { t } = useTranslation();
  return (
    <footer className="footer-container">
      <div className="footer-top">
        <div className="footer-brand">
          <Link to="/" className="footer-brand-logo">
            <img src={logo} alt="StarView Cinema" />
            <span>StarView Cinema</span>
          </Link>
          <p className="footer-tagline">{t('footer.tagline')}</p>
          <div className="footer-social">
            <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" aria-label="Facebook">Facebook</a>
            <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" aria-label="X">X</a>
            <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" aria-label="Instagram">Instagram</a>
          </div>
        </div>

        <div className="footer-section">
          <div className="footer-column">
            <h4 className="footer-heading">{t('footer.ourCompany')}</h4>
            <ul className="footer-list">
              <li><Link to="/get-the-app">Get the App</Link></li>
              <li><Link to="/starview-x">StarView X</Link></li>
              <li><Link to="/watch-parties">Watch Parties</Link></li>
              <li><Link to="/coming-soon">Trending Now</Link></li>
              <li><Link to="/our-brands">{t('footer.ourBrands')}</Link></li>
              <li><Link to="/contact-us">{t('footer.contactUs')}</Link></li>
              <li><Link to="/faqs">{t('footer.faqs')}</Link></li>
              <li><Link to="/corporate-information">{t('footer.corporateInformation')}</Link></li>
              <li><Link to="/investor-connect">{t('footer.investorConnect')}</Link></li>
              <li><Link to="/investor-relations">{t('footer.investorRelations')}</Link></li>
              <li><Link to="/media-center">{t('footer.mediaCenter')}</Link></li>
              <li><Link to="/careers">{t('footer.careers')}</Link></li>
              <li><Link to="/drive">{t('footer.driveWithUs')}</Link></li>
              <li><Link to="/associate-portal">{t('footer.associatePortal')}</Link></li>
            </ul>
          </div>

          <div className="footer-column">
            <h4 className="footer-heading">{t('footer.movies')}</h4>
            <ul className="footer-list">
              <li><Link to="/Showtimes">{t('footer.movies')}</Link></li>
              <li><Link to="/theatres">{t('footer.theatres')}</Link></li>
              <li><Link to="/ratings-information">{t('footer.ratingsInformation')}</Link></li>
              <li><Link to="/formats/imax">{t('footer.atStarView', { format: 'IMAX' })}</Link></li>
              <li><Link to="/formats/dolby-cinema">{t('footer.atStarView', { format: 'Dolby Cinema' })}</Link></li>
              <li><Link to="/formats/3d">{t('footer.atStarView', { format: '3D' })}</Link></li>
              <li><Link to="/formats/apple-vision">{t('footer.atStarView', { format: 'Apple Vision' })}</Link></li>
              <li><Link to="/formats/vr">{t('footer.atStarView', { format: 'VR' })}</Link></li>
            </ul>
          </div>

          <div className="footer-column">
            <h4 className="footer-heading">{t('footer.legal')}</h4>
            <ul className="footer-list">
              <li><Link to="/vulnerability-reporting">{t('footer.vulnerabilityReporting')}</Link></li>
              <li><Link to="/california-collection-notice">{t('footer.californiaNotice')}</Link></li>
              <li><Link to="/privacy-policy">{t('footer.privacyPolicy')}</Link></li>
              <li><Link to="/terms-and-conditions">{t('footer.terms')}</Link></li>
              <li><Link to="/starview-cinema-terms-and-conditions">{t('footer.starviewTerms')}</Link></li>
            </ul>
          </div>

          <div className="footer-column footer-column-newsletter">
            <h4 className="footer-heading">{t('footer.stayInTheLoop')}</h4>
            <p className="footer-newsletter-copy">{t('footer.newsletterCopy')}</p>
            <form className="footer-newsletter" onSubmit={e => { e.preventDefault(); alert(t('footer.subscribedThanks')); }}>
              <input type="email" placeholder={t('footer.yourEmail')} required />
              <button type="submit">{t('footer.subscribe')}</button>
            </form>
            <a href="mailto:contact@starviewcinema.com" className="footer-contact-link">{t('footer.contactUs')}</a>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        &copy; {new Date().getFullYear()} StarView Cinema. {t('footer.allRightsReserved')}
        <Link to="/admin" className="footer-admin-link">Admin</Link>
      </div>
    </footer>
  );
};

export default Footer;
